import styled, { css } from 'styled-components'
import LibText from '../../Text'
import { COLORS } from 'consts/colors'

export const TabbarItem = styled.div`
  display: flex;
  justify-content: center;
  // Flex-basis comes from parent wrappers style
`

interface ITextProps {
  $isActive?: boolean
}

export const Text = styled(LibText)<ITextProps>`
  z-index: 2;
  line-height: 15px;
  padding-bottom: 17px;
  cursor: pointer;
  ${props => {
    if (props.$isActive) {
      return css`
        cursor: default;
        pointer-events: none;
      `
    }

    return css`
      &:hover {
        color: ${COLORS.primaryDark};
      }
    `
  }}
`
